<template>
   <div class="pd-layout">
      <BreadCrumbs>
         <template v-slot:actions>
            <ClientOnly>
               <Btn
                  :text="{ do: 'Save', done: 'Saved', undo: 'Unsave' }"
                  class="yellow"
                  action
                  :actionActive="isSaved"
                  @handle-action="handleSavePd"
               >
                  <IconBookmarkFilled v-if="isSaved" />
                  <IconBookmark v-else />
               </Btn>
            </ClientOnly>
         </template>
      </BreadCrumbs>
      <div class="pd-wrapper">
         <NuxtPage />
      </div>
   </div>
</template>
<script setup lang="ts">
import IconBookmark from "~/assets/images/icons/bookmark.svg?component";
import IconBookmarkFilled from "~/assets/images/icons/bookmark-filled.svg?component";

const route = useRoute();
const { savePdToProfile, pdCourse, queryPDsBySlug } = usePd();
const { profilePd, getProfilePd } = useProfile();

// DATA ================
// if (profilePd.value == null) {
await useLazyAsyncData("profile-pd", () => getProfilePd());
// }
// if (pdCourse.value == null) {
await useLazyAsyncData(`pd-section-${route.params?.course}`, () =>
   queryPDsBySlug(route.params?.course)
);
// }

// COMPUTED ================
const isSaved = computed(() => {
   let found = false;
   profilePd.value?.length &&
      profilePd.value?.forEach((item) => {
         item?.id === pdCourse?.value?.id && (found = true);
      });
   return found;
});

// METHODS ================
const handleSavePd = () => {
   savePdToProfile(
      route.params?.course,
      isSaved.value ? "DELETE" : "POST",
      pdCourse?.value?.title
   );
};
</script>
